var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiTsTextHeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,1V24h-1V1H2.5c-.83,0-1.5,.67-1.5,1.5v1.5H0v-1.5C0,1.12,1.12,0,2.5,0H18.5c1.38,0,2.5,1.12,2.5,2.5v1.5h-1v-1.5c0-.83-.67-1.5-1.5-1.5h-7.5Zm9,21.71V8.29l3.15,3.15,.71-.71-3.29-3.29c-.58-.58-1.54-.58-2.12,0l-3.29,3.29,.71,.71,3.15-3.15v14.41l-3.15-3.15-.71,.71,3.29,3.29c.29,.29,.68,.44,1.06,.44s.77-.15,1.06-.44l3.29-3.29-.71-.71-3.15,3.15Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiTsTextHeight);
export default __webpack_public_path__ + "static/media/fi-ts-text-height.31564f14cc82d1b376ed5b90392dad29.svg";
export { ForwardRef as ReactComponent };